import {SteuernummerFormat, SteuernummerHelper, WizardPageBaseComponent} from '@utils-lib';
import {Component, OnInit} from '@angular/core';
import {BisherigePersoenlicheVerhaeltnisseAngaben, Steuernummer} from '@nachdigal';
import {ActivatedRoute} from '@angular/router';

@Component({
    selector: 'common-ui-bisherige-persoenliche-verhaeltnisse-angaben',
    templateUrl: './bisherige-persoenliche-verhaeltnisse-angaben.component.html'
})
export class BisherigePersoenlicheVerhaeltnisseAngabenComponent
    extends WizardPageBaseComponent<BisherigePersoenlicheVerhaeltnisseAngaben> implements OnInit {

    static nutzdatenPath = 'bisherigePersoenlicheVerhaeltnisseAngaben';
    static route = 'bisherige-persoenliche-verhaeltnisse-angaben';

    public isZugezogen: boolean;
    public hasEstSteuernummer: boolean;
    public showSteuernummerEhepartner: boolean;

    constructor(protected readonly activatedRoute: ActivatedRoute) {
        super(activatedRoute);
    }

    public ngOnInit(): void {
        super.ngOnInit();

        this.isZugezogen = !!this.data.bisherigeAdresse;
        this.hasEstSteuernummer = !!this.data.estSteuernummer || !!this.data.estSteuernummerEhepartner;
        this.showSteuernummerEhepartner = !!this.data.estSteuernummerEhepartner;
    }

    public onEstSteuernummerPicked(item: Steuernummer): void {
        this.hasEstSteuernummer = true;
        this.data.estSteuernummer = item;
    }

    public getSteuernummerMask(finanzamtnummer: string): SteuernummerFormat {
        return SteuernummerHelper.getMaskFormat(finanzamtnummer);
    }

    public clearSteuernummerInput($event: unknown): void {
        if (!$event) {
            this.data.estSteuernummer = null;
            this.data.estSteuernummerEhepartner = null;
        }
    }

    public clearPartnerSteuernummerInput($event: unknown): void {
        if (!$event) {
            this.data.estSteuernummerEhepartner = null;
        }
    }

    public clearFreuhereAdresse($event: unknown): void {
        if (!$event) {
            this.data.bisherigeAdresse = null;
        }
    }

    protected getStammdatenMappingRules(): Map<string, unknown | Array<unknown>> {
        return new Map<string, unknown | Array<unknown>>([
            ['estSteuernummer', this.stammdaten?.antragsteller?.estSteuernummer]
        ]);
    }

}
